const isNil = (value: any) => value == null;

export { isNil };
